<template>
    <div class="py-10">
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('consultants::form.title.general_information') }}</h5>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.gmc_number"
                    :label="t('consultants::form.label.gmc_number')"
                    type="number"
                    :readonly="readOnlyRules"
                    :rules="validationRules.gmc_number"
                    mandatory
                ></b-input>
            </v-col>
            <v-col lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.company_name"
                    :label="t('consultants::form.label.company_name')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.company_name"
                    mandatory
                ></b-input>
            </v-col>

            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.surname"
                    :label="t('consultants::form.label.surname')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.surname"
                    mandatory
                ></b-input>
            </v-col>

            <v-col lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.forename"
                    :label="t('consultants::form.label.forename')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.forename"
                    mandatory
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('consultants::form.title.address') }}</h5>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.address"
                    :label="t('consultants::form.label.address')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.address"
                    mandatory
                ></b-input>
            </v-col>
            <v-col lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.post_code"
                    :label="t('consultants::form.label.post_code')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.post_code"
                    mandatory
                ></b-input>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('consultants::form.title.contact_details') }}</h5>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.phone"
                    :label="t('consultants::form.label.phone')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.phone"
                    mandatory
                ></b-input>
            </v-col>
            <v-col lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.fax"
                    :label="t('consultants::form.label.fax')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.fax"
                ></b-input>
            </v-col>
            <v-col cols="12" lg="4" class="py-0">
                <b-input
                    to-mutate="consultants::consultant.email"
                    :label="t('consultants::form.label.email')"
                    :readonly="readOnlyRules"
                    :rules="validationRules.email"
                    mandatory
                ></b-input>
            </v-col>
            <v-col lg="4" class="py-0">
                <div style="width: max-content" class="pl-3">
                    <b-switch
                        to-mutate="consultants::consultant.can_be_sent_letters"
                        :label="t('consultants::form.label.letters_sent')"
                        :readonly="readOnlyRules"
                    ></b-switch>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h5 class="m-0">{{ t('consultants::form.title.credentials') }}</h5>
            </v-col>
            <v-col cols="6" md="2">
                <div class="pl-3">
                    <p class="mb-0">{{ t('consultants::form.label.registered') }}</p>
                    <b-switch
                        to-mutate="consultants::consultant.is_registered"
                        :label="''"
                        :readonly="readOnlyRules"
                    ></b-switch>
                </div>
            </v-col>
            <v-col cols="6" md="2">
                <p class="mb-0">{{ t('consultants::form.label.rcop_member') }}</p>
                <b-switch
                    to-mutate="consultants::consultant.is_rcop_member"
                    :label="''"
                    :readonly="readOnlyRules"
                ></b-switch>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <p class="mb-0">{{ t('consultants::form.label.srop') }}</p>
                <b-switch
                    to-mutate="consultants::consultant.specialist_register_of_psychiatrists"
                    :label="''"
                    :readonly="readOnlyRules"
                ></b-switch>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            readOnlyRules: !this.can('api.v1.consultants.update') && this.can('api.v1.consultants.show'),
            validationRules: {
                gmc_number: [(v) => !!v || t('users::validation.field.required')],
                company_name: [(v) => !!v || t('users::validation.field.required')],
                surname: [(v) => !!v || t('users::validation.field.required')],
                forename: [(v) => !!v || t('users::validation.field.required')],
                address: [(v) => !!v || t('users::validation.field.required')],
                post_code: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.postCode],
                phone: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.phone],
                fax: [this.$root.rules.fax],
                email: [(v) => !!v || t('users::validation.field.required'), this.$root.rules.email],
            },
        };
    },
};
</script>

<style></style>
